import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';

import { Title } from 'app/src/styles';
import { useSearchParams } from 'app/src/utils/routing';

import AuthButton from './AuthButton';
import { AUTHORIZE_QUICKBOOKS } from './queries';

const Auth = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const realmId = searchParams.get('realmId');

  const [getQuickbooksToken] = useMutation(
    AUTHORIZE_QUICKBOOKS, {
      variables: { code, realmId },
      onCompleted: data => { console.log(data) },
    }
  );

  useEffect(() => {
    if (code) {
      getQuickbooksToken();
    }
  }, []);


  return (
    <View>
      <Title>Quickbooks Authorization</Title>

      <AuthButton onCompleted={() => setRedirect(true)} />
    </View>
  );
};

export default Auth;
